import gql from 'graphql-tag';

export const weightByRoleByIndustryFragment = gql`
  fragment weightByRoleByIndustryFragment on WeightByRoleByIndustry {
    dokkioClass
    agency {
      dokkioClass
      creative
      new_business
      account_management
      marketing
      finance
      it
      other
    }
    construction {
      dokkioClass
      design
      engineering
      operations
      marketing
      it
      other
    }
    cpg {
      dokkioClass
      marketing
      sales
      product_development
      operations
      finance
      it
      other
    }
    distribution {
      dokkioClass
      operations
      sales
      marketing
      finance
      it
      other
    }
    education_k12 {
      dokkioClass
      teaching
      administration
      board_member
      it
      other
    }
    education_higher {
      dokkioClass
      teaching
      research
      administration
      relations
      student_affairs
      it
      other
    }
    freelance {
      dokkioClass
      marketing
      consulting
      finance
      business_development
      it
      other
    }
    business {
      dokkioClass
      sales
      operations
      customer_service
      finance
      it
      management
      other
    }
    government {
      dokkioClass
      agency
      state
      local
      legislative
      executive
      it
      other
    }
    investing {
      dokkioClass
      venture_capital
      family_office
      hedge_fund
      broker_dealer
      advisory
      other
    }
    law {
      dokkioClass
      corporate
      litigation
      criminal
      family_law
      ip_law
      other
    }
    manufacturing {
      dokkioClass
      sales
      marketing
      product_development
      finance
      operations
      it
      other
    }
    medical {
      dokkioClass
      physician
      teaching
      research
      finance
      other
    }
    non_profit {
      dokkioClass
      management
      board_member
      development
      relations
      finance
      other
    }
    professional_services {
      dokkioClass
      business_development
      account_management
      marketing
      finance
      operations
      other
    }
    real_estate {
      dokkioClass
      sales
      marketing
      operations
      property_management
      finance
      other
    }
    retail {
      dokkioClass
      merchandising
      operations
      real_estate
      finance
      it
      other
    }
    technology {
      dokkioClass
      product
      marketing
      sales
      account_management
      finance
      other
    }
    wholesale {
      dokkioClass
      logistics
      sales
      operations
      finance
      it
      other
    }
    other {
      dokkioClass
      sales
      operations
      customer_service
      finance
      it
      management
      other
    }
    personal {
      dokkioClass
      home
      family
      sports
      organizations
      school
      health
      other
    }
  }
`;
export default weightByRoleByIndustryFragment;
